import { lazy, Route } from '@tanstack/router'

import { rootRoute } from './root'

const MetaRegister = lazy(() => import('../pages/register-meta'))

export type RegisterMetaSearch = {
  referral?: string
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  uid?: string
  fbclid?: string
  fbp?: string
}

export const registerMetaRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/register-meta',
  component: MetaRegister,
  validateSearch: (search: Record<string, unknown>): RegisterMetaSearch => {
    return search as RegisterMetaSearch
  },
})
